<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Customer enquiry</h1>
    <app-navpath />
  </div>

  <section class="content-container">
    <h2 class="sub-heading w-full border-b">Search criteria</h2>
    <app-data-form [dataFields]="form" />
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn misc-btn" (click)="search()">
        <fa-icon [icon]="faMagnifyingGlass" class="mr-1" />Search
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faBroom" class="mr-1" />Clear
      </button>
    </div>
  </section>

  <section
    class="content-container mt-6"
    *ngIf="tableEntries.length > 0"
  >
    <app-data-table
      [tableHeaders]="tableHeaders"
      [tableEntries]="tableEntries"
      [pageSize]="50"
    />
  </section>
</div>
